import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { IAppEntityService, ITelemetryService } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
import { onSdkError } from './messageHandlingUtils';

/**
 * Responsible for pages.tabs module related message requests.
 */
export class AppEntityMessageHandler extends BaseMessageHandler {
  constructor(
    protected appSdkHost: HostedWebContentSdkService,
    protected appEntityService?: IAppEntityService,
    protected telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }
  public initHandlers(): void {
    this.registerHandler(
      SdkMessageTypes.appEntity.selectAppEntity,
      (_, threadId: string, categories: string[]) => this.appEntityService!.selectAppEntity(threadId, categories),
      {
        errorCallback: async (error, scenario) => {
          const finalError = await onSdkError(SdkMessageTypes.appEntity.selectAppEntity, error, scenario);
          return [null, finalError];
        },
        isPrivate: true,
      }
    );
  }
  protected validateDependencies() {
    if (!this.appEntityService) {
      throw 'No appEntityService provided';
    }
  }
}
